define(['exports', 'react', 'lodash', '../../i18n', 'react-material-card', './SectionCommonHeader', './CoveredConceptsTable', './ProblemAnalysisList'], function (exports, _react, _lodash, _i18n, _reactMaterialCard, _SectionCommonHeader, _CoveredConceptsTable, _ProblemAnalysisList) {
	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _react2 = _interopRequireDefault(_react);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _i18n2 = _interopRequireDefault(_i18n);

	var _reactMaterialCard2 = _interopRequireDefault(_reactMaterialCard);

	var _SectionCommonHeader2 = _interopRequireDefault(_SectionCommonHeader);

	var _CoveredConceptsTable2 = _interopRequireDefault(_CoveredConceptsTable);

	var _ProblemAnalysisList2 = _interopRequireDefault(_ProblemAnalysisList);

	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : {
			default: obj
		};
	}

	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}

	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);
			if (staticProps) defineProperties(Constructor, staticProps);
			return Constructor;
		};
	}();

	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}

		return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
		}

		subClass.prototype = Object.create(superClass && superClass.prototype, {
			constructor: {
				value: subClass,
				enumerable: false,
				writable: true,
				configurable: true
			}
		});
		if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	var MCQSection = function (_Component) {
		_inherits(MCQSection, _Component);

		function MCQSection() {
			_classCallCheck(this, MCQSection);

			return _possibleConstructorReturn(this, (MCQSection.__proto__ || Object.getPrototypeOf(MCQSection)).apply(this, arguments));
		}

		_createClass(MCQSection, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    index = _props.index,
				    sectionType = _props.sectionType,
				    _props$section = _props.section,
				    _props$section$name = _props$section.name,
				    name = _props$section$name === undefined ? '' : _props$section$name,
				    concepts = _props$section.concepts,
				    questions = _props$section.questions,
				    numberOfQuestions = _props$section.numberOfQuestions;


				var questionFormat = _lodash2.default.isObject(questions) ? _lodash2.default.keys(questions).map(function (key) {
					return key.toUpperCase();
				}).join(', ') : sectionType;

				return _react2.default.createElement(
					'div',
					{ level: 1, className: 'card clearfix mx4 mt2 px4 py3 white-background' },
					_react2.default.createElement(_SectionCommonHeader2.default, {
						title: _i18n2.default.t('dk-ui-lib.reports.section') + ' ' + index + ' - ' + name.toUpperCase(),
						questionsCount: numberOfQuestions,
						questionFormat: questionFormat }),
					_react2.default.createElement(_CoveredConceptsTable2.default, { conceptsCovered: concepts }),
					_react2.default.createElement(_ProblemAnalysisList2.default, {
						sectionType: sectionType,
						problemsAnalysis: questions })
				);
			}
		}]);

		return MCQSection;
	}(_react.Component);

	exports.default = MCQSection;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/candidate-reports/MCQSection.js
// module id = 1194
// module chunks = 0